import { Suspense, lazy, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Loading from "./components/Loading";

const Builder = lazy(() => import("./pages/commons/BUILDER"));
const BuilderVisioExpert = lazy(() => import("./pages/commons/BUILDER_VISIO_EXPERIMENTE"));
const BuilderResidentiel = lazy(() => import("./pages/commons/BUILDER_RESIDENTIEL"));
const WhoAreYou = lazy(() => import("./pages/commons/WHOAREYOU"));
const AUTO_GEO_REDIRECT = lazy(() => import("./components/AutoGeoLocation"));

const Checkout = lazy(() => import("./components/Checkout"));
const CheckoutSuccess = lazy(() => import("./components/Checkout/Success"));
const CheckoutSuccessResidentiel = lazy(() => import("./components/Checkout/SuccessResidentiel"));

const firstVisitedPageParam = new URLSearchParams(window.location.search).get('first_visited_page');
if (firstVisitedPageParam) { localStorage.setItem('first_visited_page', decodeURIComponent(firstVisitedPageParam)); }
const referrerPageParam = new URLSearchParams(window.location.search).get('referrer_page');
if (referrerPageParam) { localStorage.setItem('referrer_page', decodeURIComponent(referrerPageParam)); }
if (window !== window.parent) {
  window.parent.postMessage({ type: 'getHistory' }, 'https://oserlechangement.com');
  window.addEventListener('message', (event) => {
    if (event.origin !== 'https://oserlechangement.com') return;
    if (event.data.type === 'historyData') {
      const linksHistory = event.data.data
      localStorage.setItem('links_history', JSON.stringify(linksHistory));
    }
  });
}

// Récupérer le Client ID de GA4
const getClientIdFromCookie = () => {
  const gaCookie = document.cookie.split(";").find((cookie) => cookie.trim().startsWith("_ga="));
  if (!gaCookie) return null;

  const gaValue = gaCookie.split("=")[1];
  const clientId = gaValue.replace(/^GA\d+\.\d+\./, "");
  return clientId;
};

export default function App() {

  // Stocker et envoyer le Client ID de GA4
  useEffect(() => {
    const interval = setInterval(() => {
      const clientId = getClientIdFromCookie();
      if (clientId) {
        localStorage.setItem("cid", clientId);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "initialisation",
          client_id: clientId
        });
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return <Suspense fallback={<Loading />}>
      <BrowserRouter>
        <Routes>
          {/* NOT FOUNDED PAGE OR ROOT PAGE ! */}
          <Route exact path="/" element={<WhoAreYou />} />
          <Route path="*" element={<WhoAreYou />} />

          {/* Visio Experimente */}
          <Route path="/visio-expert" element={<BuilderVisioExpert resolve="/ue/visio" />} />
          <Route path="/fr/visio-expert" element={<BuilderVisioExpert resolve="/ue/visio" />} />
          <Route path="/be/visio-expert" element={<BuilderVisioExpert resolve="/ue/visio" />} />
          <Route path="/ma/visio-expert" element={<BuilderVisioExpert resolve="/ma/visio" />} />
          <Route path="/ca/visio-expert" element={<BuilderVisioExpert resolve="/ca/visio" />} />
          <Route path="/ch/visio-expert" element={<BuilderVisioExpert resolve="/ue/visio" />} />
          <Route path="/lu/visio-expert" element={<BuilderVisioExpert resolve="/ue/visio" />} />
          <Route path="/mc/visio-expert" element={<BuilderVisioExpert resolve="/ue/visio" />} />

          {/* Geolocalisation */}
          <Route path="/use-auto-locate" element={<AUTO_GEO_REDIRECT />} />

          {/* Paiement */}
          <Route path="/checkout">
            <Route index element={<Checkout />} />
            <Route path="success" element={<CheckoutSuccess />} />
            <Route path="residentiel/success" element={<CheckoutSuccessResidentiel />} />
          </Route>

          {/* Sur place */}
          <Route path="/fr/oserlechangement">
              <Route path="/fr/oserlechangement/auvergne-rhone-alpes" element={<Builder resolve="/fr/oserlechangement/auvergne-rhone-alpes" resolveVisio="/ue/visio" />} />
              <Route path="/fr/oserlechangement/bourgogne-franche-comte" element={<Builder resolve="/fr/oserlechangement/bourgogne-franche-comte" resolveVisio="/ue/visio" />} />
              <Route path="/fr/oserlechangement/bretagne" element={<Builder resolve="/fr/oserlechangement/bretagne" resolveVisio="/ue/visio" />} />
              <Route path="/fr/oserlechangement/centre-val-de-loire" element={<Builder resolve="/fr/oserlechangement/centre-val-de-loire" resolveVisio="/ue/visio" />} />
              <Route path="/fr/oserlechangement/corse" element={<Builder resolve="/fr/oserlechangement/corse" resolveVisio="/ue/visio" />} />
              <Route path="/fr/oserlechangement/grand-est" element={<Builder resolve="/fr/oserlechangement/grand-est" resolveVisio="/ue/visio" />} />
              <Route path="/fr/oserlechangement/hauts-de-france" element={<Builder resolve="/fr/oserlechangement/hauts-de-france" resolveVisio="/ue/visio" />} />
              <Route path="/fr/oserlechangement/ile-de-france" element={<Builder resolve="/fr/oserlechangement/ile-de-france" resolveVisio="/ue/visio" />} />
              <Route path="/fr/oserlechangement/normandie" element={<Builder resolve="/fr/oserlechangement/normandie" resolveVisio="/ue/visio" />} />
              <Route path="/fr/oserlechangement/nouvelle-aquitaine" element={<Builder resolve="/fr/oserlechangement/nouvelle-aquitaine" resolveVisio="/ue/visio" />} />
              <Route path="/fr/oserlechangement/occitanie" element={<Builder resolve="/fr/oserlechangement/occitanie" resolveVisio="/ue/visio" />} />
              <Route path="/fr/oserlechangement/pays-de-la-loire" element={<Builder resolve="/fr/oserlechangement/pays-de-la-loire" resolveVisio="/ue/visio" />} />
              <Route path="/fr/oserlechangement/provence-alpes-cote-d-azur" element={<Builder resolve="/fr/oserlechangement/provence-alpes-cote-d-azur" resolveVisio="/ue/visio" />} />
              <Route path="/fr/oserlechangement/dom-tom" element={<Builder resolve="/fr/oserlechangement/dom-tom" resolveVisio="/ue/visio" />} />
          </Route>
          <Route path="/be/oserlechangement/belgique" element={<Builder resolve="/be/oserlechangement/belgique" resolveVisio="/ue/visio" />} />
          <Route path="/ma/oserlechangement/maroc" element={<Builder resolve="/ma/oserlechangement/maroc" resolveVisio="/ma/visio" />} />
          <Route path="/ca/oserlechangement/canada" element={<Builder resolve="/ca/oserlechangement/canada" resolveVisio="/ca/visio" />} />
          <Route path="/ch/oserlechangement/suisse" element={<Builder resolve="/ch/oserlechangement/suisse" resolveVisio="/ue/visio" />} />
          <Route path="/lu/oserlechangement/luxembourg" element={<Builder resolve="/lu/oserlechangement/luxembourg" resolveVisio="/ue/visio" />} />
          <Route path="/mc/oserlechangement/monaco" element={<Builder resolve="/mc/oserlechangement/monaco" resolveVisio="/ue/visio" />} />

          {/* Residentiel */}
          <Route path="/fr/residentiel/montpellier-sete" element={<BuilderResidentiel resolve="/fr/residentiel/montpellier-sete" />} />
          <Route path="/fr/residentiel/pornic/saint-nazaire" element={<BuilderResidentiel resolve="/fr/residentiel/pornic/saint-nazaire" />} />
          <Route path="/ma/residentiel/marrakech-ecolodges-farm" element={<BuilderResidentiel resolve="/ma/residentiel/marrakech-ecolodges-farm" />} />

        </Routes>
      </BrowserRouter>
  </Suspense>
}